import React, { Fragment } from 'react';  
import "./App.css"
import Home from './screens/Home';
import About from './screens/About';
import Services from './screens/Services';
import Contact from './screens/Contact';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import LoginScreen from "./AdminScreens/LoginScreen";
import BlogsScreen from "./AdminScreens/BlogsScreens/BlogsScreen";
import AdminScreen from "./AdminScreens/AdminScreen";
import { Routes, Route, Navigate } from 'react-router-dom';

import PreventativeMaintenance from './screens/individualServices/PreventativeMaintenance';
import DigitalSignageSolutions from './screens/individualServices/DigitalSignageSolutions';
import EverythingAudio from './screens/individualServices/EverythingAudio';
import NetworkDesign from './screens/individualServices/NetworkDesign';
import LogisticsProcurement from './screens/individualServices/LogisticsProcurement';
import EnvironmentSurveys from './screens/individualServices/EnvironmentSurveys';
import StructuredWiringPerfected from './screens/individualServices/StructuredWiringPerfected';
import RemoteMonitoringSupport from './screens/individualServices/RemoteMonitoringSupport';
import CallCenter from './screens/individualServices/CallCenter';
import OurClient from './screens/OurClient';
import Careers from './screens/Careers';
import BusinessAnalyst from './screens/individualCareers/BusinessAnalyst';
import News from './screens/news';
import NewsInner from './screens/newsInner';
import CaseStudies from './screens/CaseStudies';
import CaseStudiesInner from './screens/CaseStudiesInner';

import CaseStudyEditScreen from "./AdminScreens/CaseStudyScreens/CaseStudyEditScreen";
import CaseStudyListScreen from "./AdminScreens/CaseStudyScreens/CaseStudyListScreen";
import ContactUsa from './screens/ContactUsa';
import FoodAndHospitality from './screens/CaseStudies/FoodAndHospitality';
import StructuredCabling from './screens/CaseStudies/StructuredCabling';
import SpecializedSector from './screens/CaseStudies/SpecializedSector';
import Education from './screens/CaseStudies/Education';
import Commercial from './screens/CaseStudies/Commercial';
import Grocery from './screens/CaseStudies/Grocery';
import Media from './screens/Media';
import NovaStarCE from './screens/individualServices/NovaStarCE';
import PrivacyStatement from './screens/PrivacyStatement';

const App = () => {

  return (
    <Fragment > 
      
      <Routes>
        <Fragment >
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/"></Navigate>} />
           <Route path="/about" element={<About/>} />
            <Route path="/services" element={<Services/>} />
            <Route path="/client" element={<OurClient/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/contact-usa" element={<ContactUsa/>} />
            <Route path="/careers" element={<Careers/>} />
            <Route path="/media" element={<Media/>} />
            {/* <Route path="/blog" element={<News/>} /> */}
            
            {/* <Route path="/case-studies" element={<CaseStudies/>} /> */}
            <Route path="/casestudy/:id" element={<CaseStudiesInner />} />


              {/* Individual services */}
            <Route path="/preventative-maintenance" element={<PreventativeMaintenance/>} />
            <Route path="/digital-signage-solution" element={<DigitalSignageSolutions/>} />
            <Route path="/everything-audio" element={<EverythingAudio/>} />
            <Route path="/network-design" element={<NetworkDesign/>} />
            <Route path="/structured-wiring-perfected" element={<StructuredWiringPerfected/>} />
            <Route path="/logistics-procurement" element={<LogisticsProcurement/>} />
            <Route path="/environment-surveys" element={<EnvironmentSurveys/>} />
            <Route path="/remote-monitoring-support" element={<RemoteMonitoringSupport/>} />
            <Route path="/call-center-support-hub-support" element={<CallCenter/>} />
            <Route path="/novastar-certified-engineers" element={<NovaStarCE/>} />

            {/* Individual careers */}
            {/* <Route path="/business-analyst" element={<BusinessAnalyst/>} /> */}


            {/* Case Studies */}
            <Route path="/case-study/fast-food-and-hospitality" element={<FoodAndHospitality/>} />
            <Route path="/case-study/comprehensive-structured-cabling" element={<StructuredCabling/>} />
            <Route path="/case-study/commercial-specialized-sectors" element={<SpecializedSector/>} />
            <Route path="/case-study/education-finance-health-care" element={<Education/>} />
            <Route path="/case-study/commercial-and-large-scale" element={<Commercial/>} />
            <Route path="/case-study/grocery" element={<Grocery/>} />

           <Route path="/blog" element={<News/>} />
          <Route path="/blogs/:id" element={<NewsInner />} />

           <Route path="/privacy-statment" element={<PrivacyStatement/>} />

          <Route path="/admin" element={<AdminScreen />} />
          <Route path="/admin/blogs" element={<BlogsScreen />} />
          <Route path="/login" element={<LoginScreen />} />

          <Route
            path="/admin/casestudy/:id/edit"
            element={<CaseStudyEditScreen />}
          />
          <Route path="/admin/casestudy" element={<CaseStudyListScreen />} />


        </Fragment>
      </Routes>
      <Footer /> 
    </Fragment>
  );
};
export default App; 